/**
 * Wat er misging bij een aanroep, in de vorm die een scherm kan uitleggen (FBK-2).
 *
 * De testers zagen "Ophalen is niet gelukt" en "Deze naam bestaat al" terwijl ze een recht misten.
 * Een server die `403 POLICY_DENIED` antwoordt, zegt welk recht ontbreekt ("Je hebt het recht
 * shortcuts.shortcut.manage niet."); dat hoort op het scherm te komen, niet een zin die naar de
 * verbinding of naar de invoer wijst.
 */

export type ProblemKind = 'denied' | 'notFound' | 'invalid' | 'other';

interface ProblemLike {
  code?: unknown;
  status?: unknown;
  detail?: unknown;
}

function asProblem(error: unknown): ProblemLike {
  return error && typeof error === 'object' ? (error as ProblemLike) : {};
}

/** Een ontbrekend recht, een onbestaand ding, afgewezen invoer, of iets anders (netwerk, server). */
export function problemKind(error: unknown): ProblemKind {
  const problem = asProblem(error);
  if (problem.code === 'POLICY_DENIED' || problem.code === 'FORBIDDEN' || problem.status === 403) {
    return 'denied';
  }
  if (problem.code === 'NOT_FOUND' || problem.status === 404) return 'notFound';
  if (problem.code === 'VALIDATION_FAILED') return 'invalid';
  return 'other';
}

/** Het recht dat de server noemde (`POLICY_DENIED`), of `null`. */
export function deniedRight(error: unknown): string | null {
  const problem = asProblem(error);
  if (problem.code !== 'POLICY_DENIED' || typeof problem.detail !== 'string') return null;
  const match = /recht\s+([\w.:-]+)\s+niet/.exec(problem.detail);
  return match?.[1] && match[1] !== 'onbekend' ? match[1] : null;
}

/** De module van een recht: `shortcuts.shortcut.manage` → `shortcuts`. */
export function rightArea(right: string): string {
  return right.split(/[.:]/)[0] ?? right;
}
